import React from 'react';
import { useStudioTypeSize } from '../../StudioTypeScale';
import { studioCopy } from '../../../../utils/contentCopy';
import EditorialFrame, { type EditorialInjectedProps, type EditorialLayoutProps } from './EditorialFrame';

const EditorialStatHighlightContent: React.FC<EditorialInjectedProps & { content: any }> = ({
  content,
  tokens,
  isStory,
  locale
}) => {
  const t = tokens!;
  const typeSize = useStudioTypeSize();
  const chipLabel = studioCopy.statChip(content, locale);

  return (
    <div>
      <div
        style={{
          color: t.accent,
          fontSize: typeSize(isStory ? 10 : 8.5),
          fontWeight: 800,
          letterSpacing: 2.2,
          textTransform: 'uppercase'
        }}
      >
        {chipLabel}
      </div>
      <div
        style={{
          marginTop: isStory ? 16 : 12,
          color: t.accent,
          fontFamily: t.serif,
          fontSize: typeSize(isStory ? 64 : 50),
          fontStyle: 'italic',
          fontWeight: 700,
          letterSpacing: '-2.4px',
          lineHeight: 0.95
        }}
      >
        {content.stat}
      </div>
      <div
        style={{
          maxWidth: 285,
          marginTop: isStory ? 12 : 9,
          paddingTop: isStory ? 15 : 11,
          borderTop: `3px solid ${t.ink}`,
          color: t.ink,
          fontFamily: t.serif,
          fontSize: typeSize(isStory ? 22 : 18),
          fontWeight: 700,
          lineHeight: 1.3
        }}
      >
        {content.label}
      </div>
      {content.description ? (
        <div
          style={{
            position: 'relative',
            maxWidth: 275,
            marginTop: isStory ? 28 : 20,
            padding: isStory ? '18px 18px 17px 24px' : '14px 14px 13px 20px',
            border: `1px solid ${t.line}`,
            background: t.panel,
            color: t.muted,
            fontSize: typeSize(isStory ? 13.5 : 11.5),
            fontWeight: 550,
            lineHeight: 1.62
          }}
        >
          <span
            style={{
              position: 'absolute',
              top: 0,
              bottom: 0,
              left: 0,
              width: 5,
              background: t.accent
            }}
          />
          {content.description}
        </div>
      ) : null}
    </div>
  );
};

const EditorialStatHighlightLayout: React.FC<EditorialLayoutProps> = props => (
  <EditorialFrame {...props}>
    <EditorialStatHighlightContent content={props.content || {}} />
  </EditorialFrame>
);

export default EditorialStatHighlightLayout;
